module.exports = __webpack_public_path__ + "images/category_lp/home_appliance/new/store_images/3_d9fee5e654e0a49267a19f933d40a239.png";